import React from "react";
import styles from './Layout.module.css'

const Wrapper = props => {
  const {children, className, menu, ...other} = props
  return(
    <div data-menu={menu} className={`${styles.Wrapper} ${className ? className : ''}`} {...other}>
      {children}
    </div>
  )
}

const Main = props => {
  const {children, className, ...other} = props
  return(
    <div className={`${styles.Main} ${className ? className : ''}`} {...other}>
      {children}
    </div>
  )
}

const Content = props => {
  const {children, className, ...other} = props
  return(
    <div className={`${styles.Content} ${className ? className : ''}`} {...other}>
      {children}
    </div>
  )
}

const SubContent = props => {
  const {children, className, ...other} = props
  return(
    <div className={`${styles.subContent} ${className ? className : ''}`} {...other}>
      {children}
    </div>
  )
}


const Sidebar = props => {
  const {children, className, ...other} = props
  return(
    <div className={`${styles.Sidebar} ${className ? className : ''}`} {...other}>
      {children}
    </div>
  )
}

export { Main, Content, Sidebar, Wrapper, SubContent } 